import { decodeToken } from '../helpers/validators'
import { ApiSignup } from '../infrastructure/api-signup'
import { TokenPayload } from '../interfaces/api-activation'

export const useToken = () => {
    const token = ApiSignup.defaults.headers.common.Authorization?.toString().replace('Bearer ', '')
    let payload: TokenPayload | null = null
    try {
        if (token) payload = decodeToken<TokenPayload>(token)
    } catch (error) {
        console.error(error)
    }
    return { ...payload, token, isLogged: !!payload?._id }
}

export type TokenDTO = Partial<ReturnType<typeof useToken>>
